import React, { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";
import { InputText } from "../InputText/InputText";
import { useForm } from "react-hook-form";

interface DebounceSearchProps {
  refetch?: () => void;
  placeholder?: string;
  setSearchKey: (key: string) => void;
  searchKey: string;
}

const DebounceSearch: React.FC<DebounceSearchProps> = ({
  refetch,
  placeholder,
  setSearchKey,
  searchKey
}) => {
  const [inputValue, setInputValue] = useState(searchKey);
  const { register, watch } = useForm({
    defaultValues: { search: searchKey }
  });

  const searchValue = watch("search");

  const debouncedSearch = useMemo(
    () =>
      debounce((text: string) => {
        setSearchKey(text);
      }, 400),
    [setSearchKey]
  );

  useEffect(() => {
    if (searchValue !== undefined) {
      setInputValue(searchValue);

      if (searchValue === "" || searchValue === null) {
        setSearchKey("");
        if (refetch) refetch();
        return;
      }

      debouncedSearch(searchValue);
      if (debouncedSearch) {
        return () => {
          debouncedSearch.cancel();
        };
      }
    }
  }, [searchValue, debouncedSearch, setSearchKey, refetch]);

  return (
    <>
      <InputText
        register={register}
        name="search"
        placeholder={placeholder || "Search..."}
        defaultValues={inputValue}
      />
    </>
  );
};

export default DebounceSearch;
